import { ReactNode } from 'react';

const FilterInputContainer: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className='relative flex flex-1 flex-col'>{children}</div>
);

export default FilterInputContainer;
